import React from 'react';
import { TrendingUp, BarChart3, Clock, Zap } from 'lucide-react';

const TimeSeries: React.FC = () => {
  return (
    <div className='space-y-8'>
      <div>
        <h1 className='text-3xl font-bold text-gray-900'>Time Series Analytics</h1>
        <p className='text-gray-600 mt-2'>
          High-performance time series database with real-time analytics and compression algorithms
        </p>
      </div>

      <div className='grid md:grid-cols-2 lg:grid-cols-4 gap-6'>
        <div className='card'>
          <div className='flex items-center space-x-3 mb-4'>
            <BarChart3 className='w-8 h-8 text-green-600' />
            <h3 className='text-lg font-semibold'>Metrics Ingestion</h3>
          </div>
          <p className='text-gray-600 text-sm mb-4'>
            Ingest millions of data points per second with automatic partitioning
          </p>
          <button className='btn btn-success w-full'>Start Ingestion</button>
        </div>

        <div className='card'>
          <div className='flex items-center space-x-3 mb-4'>
            <TrendingUp className='w-8 h-8 text-blue-600' />
            <h3 className='text-lg font-semibold'>Real-Time Queries</h3>
          </div>
          <p className='text-gray-600 text-sm mb-4'>
            Query time ranges with aggregations and downsampling
          </p>
          <button className='btn btn-primary w-full'>Query Data</button>
        </div>

        <div className='card'>
          <div className='flex items-center space-x-3 mb-4'>
            <Clock className='w-8 h-8 text-purple-600' />
            <h3 className='text-lg font-semibold'>Visualization</h3>
          </div>
          <p className='text-gray-600 text-sm mb-4'>
            Built-in charts and dashboards for time series data
          </p>
          <button className='btn btn-secondary w-full'>View Charts</button>
        </div>

        <div className='card'>
          <div className='flex items-center space-x-3 mb-4'>
            <Zap className='w-8 h-8 text-orange-600' />
            <h3 className='text-lg font-semibold'>Anomaly Detection</h3>
          </div>
          <p className='text-gray-600 text-sm mb-4'>
            Statistical and ML-based anomaly detection in real-time
          </p>
          <button className='btn btn-success w-full'>Detect Anomalies</button>
        </div>
      </div>

      <div className='card'>
        <h3 className='text-2xl font-bold text-gray-900 mb-6'>Time Series Demo</h3>
        <div className='bg-gray-50 rounded-lg p-6'>
          <p className='text-gray-600'>
            Interactive time series analytics demo will be shown here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TimeSeries;
